import React, { useState } from 'react';

// items: array de URLs de imagen
export default function ImageGallery({ items }) {
  const [activo, setActivo] = useState(0);
  if (!items?.length) return null;

  return (
    <div style={{ padding: '20px 22px 4px' }}>
      <div style={{ width: '100%', aspectRatio: '1 / 1', borderRadius: 'var(--r-lg)', overflow: 'hidden', marginBottom: 10, background: 'var(--cream-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={items[activo]} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div>
      {items.length > 1 && (
        <div style={{ display: 'flex', gap: 8, overflowX: 'auto' }}>
          {items.map((url, i) => (
            <button key={i} onClick={() => setActivo(i)} style={{
              width: 56, height: 56, borderRadius: 12, overflow: 'hidden', flexShrink: 0, padding: 0, cursor: 'pointer',
              border: i === activo ? '2px solid var(--forest)' : '2px solid transparent', background: 'var(--cream-dark)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
